import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { IVarValue } from '../../../interfaces/var-value';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

@Component({
    selector: 'app-var-value-item',
    standalone: true,
    templateUrl: './var-value-item.component.html',
    styleUrls: ['./var-value-item.component.css'],
    imports: [ReactiveFormsModule, FormsModule]
})
export class VarValueItemComponent  implements OnInit {

  @Input() varValue!: IVarValue;
  @Output() changeVarValue: EventEmitter<IVarValue> = new EventEmitter<IVarValue>();

  variableName!: string;
  dataType!: string;
  variableValue!: string;
  vpivId!: number;
  variableId!: number;
  versionNum!: number;
  isSeqNoEven!: boolean;

  ngOnInit() {
    if (this.varValue != null) {
      this.variableName = this.varValue.variableName;
      this.dataType = this.varValue.dataType.substring(0,1).toUpperCase() + this.varValue.dataType.slice(1).toLowerCase();
      this.variableValue = this.varValue.variableValue;
      this.vpivId = this.varValue.vpivId;
      this.variableId = this.varValue.variableId;
      this.isSeqNoEven = (this.varValue.seqNo || 0) % 2 == 0 ? true : false;
    }
  }

  onChangeVariableValue(event: any, vpivId: any) {
    // console.log('vpivId', vpivId);
    // console.log('newValue', event.target.value);
    this.changeVarValue.emit(
      {
        vpivId: vpivId,
        variableId: this.variableId,
        variableName: this.variableName,
        dataType: this.dataType,
        variableValue: event.target.value,
        versionNum: this.versionNum
      }
    );
  }

}

